// Shared owner-derivation for the CardCollection shell (ADR-0010).
// Extracted from the copy-pasted logic in SearchListRow / SearchGridView so the
// list and grid views derive owner avatars the same way.
//
// A card-item's `holders` are the binders/owners that hold it. The avatar strip
// shows the distinct owner names; `ownerColor` gives each a deterministic accent.

/**
 * Distinct owner names for a card-item's holders, in first-seen order.
 * A holder with no ownerName is attributed to "You" (the viewer's own binders);
 * multiple anonymous holders collapse to a single "You".
 * @param {Array<{ownerName?: string|null}>} holders
 * @returns {string[]}
 */
export function deriveOwners(holders) {
  if (!holders || !holders.length) return [];
  const seen = new Set();
  const result = [];
  for (const h of holders) {
    const name = h.ownerName || 'You';
    if (!seen.has(name)) {
      seen.add(name);
      result.push(name);
    }
  }
  return result;
}

/**
 * Deterministic avatar color for an owner name. Same name → same color across
 * list/grid views. (Legacy djb2-style hash; preserved so colors don't drift.)
 * @param {string} name
 * @returns {string} an `hsl(...)` color string
 */
export function ownerColor(name) {
  const str = name || '';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${Math.abs(hash) % 360}, 35%, 48%)`;
}
